import { BaseController } from '../../../../common/base/controller';
import _ from 'lodash';

export class FinanceListController extends BaseController {
  constructor(controllerService, $scope) {
    'ngInject';
    super({ controllerService, $scope });
  }

  get showFilterInfo() {
    const { finances, financesFiltered } = this;
    if (finances && financesFiltered) {
      return finances.length !== financesFiltered.length;
    }
    return false;
  }

  get enableFinanceListToggleAll() {
    return this.isFeatureActive(this.FeatureNames.FF_ENABLE_FINANCE_LIST_TOGGLE_ALL);
  }

  get disableRemoveFinanceItem() {
    return !this.isFeatureActive(this.FeatureNames.FF_DISABLE_REMOVE_FINANCE_ITEM);
  }

  $onInit() {
    this.createEditor();
  }

  createEditor() {
    this.editor = {
      item: {
        selected: true // preselect newly created item
      },
      isNew: true,
      edit: this.edit.bind(this),
      save: this.save.bind(this),
      reset: this.reset.bind(this),
      addAll: this.addAll.bind(this)
    };
  }

  edit(item) {
    // Fill editor with item
    this.editItem = item;
    this.editor.item = angular.copy(this.editItem);
    this.editor.isNew = false;
  }

  save(item) {
    // When ticket went to kwh courier, finances are null
    if (!this.finances) {
      this.finances = [];
    }

    if (this.editItem) {
      this.finances = this.finances.map((x) => x === this.editItem ? this.editor.item : x);
    }
    else {
      this.finances.push(this.editor.item);
    }

    // Saved item is always selected
    item.selected = true;

    // Saved item has no errors
    item.errors = [];

    this.onSave({ item });
    this.itemsChanged();
  }

  add(item, triggerChange = true) {
    item.selected = true;
    this.onAdd({ item });
    if (triggerChange) {
      this.itemsChanged();
    }
  }

  addAll(items) {
    items.map(item => {
      this.add(item, false);
      this.finances.push(item);
    });
    this.itemsChanged();
  }

  reset(item, options) {
    delete this.editItem;
    this.createEditor();
    this.onReset({ item });
  }

  remove(item, triggerChange = true) {
    item.selected = false;
    this.onRemove({ item });
    if (triggerChange) {
      this.itemsChanged();
    }
  }

  toggleRemove($event, item) {
    $event.stopPropagation();
    $event.preventDefault();

    if (!item.selected) {
      return this.add(item);
    }
    return this.remove(item);
  }

  toggleRemoveAll($event) {
    // If at least one item is on, remove all, otherwise add all
    let selected = _.some(this.finances, { selected: true });
    this.finances.forEach(item => {
      if (selected) {
        this.remove(item, false);
      } else {
        this.add(item, false);
      }
    });
    this.itemsChanged();
  }

  itemsChanged() {
    const { finances } = this;
    this.onChange({ finances });
  }

  clearFilter() {
    this.filterValue = '';
  }

  hasPropertyError(property, errors) {
    return _.find(errors, property);
  }
}
